import React from "react";

export default function AccountDetailsFragment({ dataUser, dataChannel }) {
   return (
      <div>
         <h2 className="font-medium text-gray-700">Account Details</h2>
         <form className="mt-4 space-y-3">
            <input
               name="email"
               placeholder="Admin Email"
               className="form-input w-full h-12 disabled:text-gray-400"
               type="text"
               value={dataUser.user_email ?? ""}
               disabled
            />
            <input
               name="full_name"
               placeholder="Admin Full Name"
               className="form-input w-full h-12 disabled:text-gray-400"
               type="text"
               value={dataUser.user_name}
               disabled
            />
            <div className="relative">
               <input
                  name="phone"
                  className="form-input w-full pl-6 h-12 disabled:text-gray-400"
                  type="tel"
                  value={dataUser.user_mobile}
                  disabled
               />
               <div className="absolute inset-0 right-auto flex items-center pointer-events-none">
                  <span className="text-sm text-gray-400 font-medium px-3">
                     +
                  </span>
               </div>
            </div>
            <input
               name="account_name"
               placeholder="Account Name"
               className="form-input w-full h-12 disabled:text-gray-400"
               type="text"
               value={dataChannel.channel_sub_sub_category}
               disabled
            />
         </form>
      </div>
   );
}
